import React from 'react';
import { Helmet } from 'react-helmet';

function About() {
  const teamMembers = [
    {
      id: 1,
      name: 'Δημήτρης Παπαδόπουλος',
      role: 'Ιδρυτής & Master Barber',
      bio: 'Με πάνω από 20 χρόνια εμπειρίας στην τέχνη του barbering, ο Δημήτρης έφερε το όραμα του Ferupen στη ζωή. Η αφοσίωσή του στην κλασική κομμωτική και τη σύγχρονη περιποίηση είναι το θεμέλιο της επιχείρησής μας.'
    },
    {
      id: 2,
      name: 'Γιώργος Αντωνίου',
      role: 'Επικεφαλής Στυλιστής',
      bio: 'Ο Γιώργος είναι ειδικός στα σύγχρονα ανδρικά κουρέματα και styling. Έχει εκπαιδευτεί στα καλύτερα barbershops της Ευρώπης και φέρνει διεθνή εμπειρία στην ομάδα μας.'
    },
    {
      id: 3,
      name: 'Μαρία Κωνσταντίνου',
      role: 'Ειδική Περιποίησης Δέρματος',
      bio: 'Η Μαρία είναι πιστοποιημένη ειδικός περιποίησης με εξειδίκευση στα φυσικά και οργανικά προϊόντα. Βοηθά τους πελάτες μας να επιλέξουν τα ιδανικά προϊόντα για τον τύπο δέρματός τους.'
    },
    {
      id: 4,
      name: 'Νίκος Βασιλείου',
      role: 'Barber Specialist',
      bio: 'Ο Νίκος ειδικεύεται στο κλασικό ξύρισμα με ξυράφι και τη φροντίδα μούσι. Η λεπτομερής δουλειά του και η προσοχή στην τεχνική τον κάνουν αγαπημένο των πελατών μας.'
    },
    {
      id: 5,
      name: 'Αλέξανδρος Μιχαήλ',
      role: 'Σύμβουλος Στυλ',
      bio: 'Ο Αλέξανδρος είναι ο fashion expert της ομάδας μας. Βοηθά τους πελάτες να βρουν το τέλειο στυλ που ταιριάζει στην προσωπικότητα και τον τρόπο ζωής τους, συνδυάζοντας grooming με ολοκληρωμένη εικόνα.'
    }
  ];

  return (
    <>
      <Helmet>
        <title>Σχετικά με το Ferupen - Η Ομάδα μας</title>
        <meta name="description" content="Γνωρίστε την ομάδα του Ferupen Barbershop. Έμπειροι επαγγελματίες αφοσιωμένοι στην τέχνη της ανδρικής περιποίησης." />
      </Helmet>

      <div className="about-container">
        <h1>Σχετικά με το Ferupen</h1>
        
        <div className="about-intro">
          <p>
            Το Ferupen Barbershop ιδρύθηκε το 2010 με ένα όραμα: να αναβιώσει την κλασική 
            εμπειρία του barbershop για τον σύγχρονο κύριο. Συνδυάζουμε την παράδοση των 
            παλιών gentleman clubs με τις πιο σύγχρονες τεχνικές και προϊόντα περιποίησης.
          </p>
          <p>
            Η φιλοσοφία μας είναι απλή: κάθε άνδρας αξίζει να νιώθει σπουδαίος. Από το 
            κλασικό ξύρισμα με ξυράφι μέχρι τα πιο μοντέρνα κουρέματα, προσφέρουμε μια 
            ολοκληρωμένη εμπειρία περιποίησης που συνδυάζει δεξιοτεχνία, χαλάρωση και στυλ.
          </p>
          <p>
            Με περισσότερους από 10,000 ευχαριστημένους πελάτες και 15 χρόνια εμπειρίας, 
            το Ferupen έχει γίνει συνώνυμο της αριστείας στην ανδρική περιποίηση. Η ομάδα 
            μας αποτελείται από παθιασμένους επαγγελματίες που αφιερώνουν την τέχνη τους 
            στο να σας κάνουν να αισθάνεστε και να φαίνεστε υπέροχα.
          </p>
        </div>

        <div className="team-section">
          <h2>Η Ομάδα μας</h2>
          <div className="team-grid">
            {teamMembers.map(member => (
              <div key={member.id} className="team-member">
                <img 
                  src={`/images/team_${member.id}.jpg`}
                  width="400"
                  height="400"
                  alt={`Team member ${member.id}`}
                />
                <h3>{member.name}</h3>
                <p className="role">{member.role}</p>
                <p className="bio">{member.bio}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default About;